export const RECEIPT_CHANNELS = Object.freeze({ EMAIL: 'email', SMS: 'sms' });

export const isChannelAvailable = (channels, medium) => channels?.[medium] !== false;

export const receiptDeliveryKey = (transactionId) => ['receipt-delivery', String(transactionId)];

// A channel counts as used while its send is on the way or delivered; a failed send frees it so
// the patient can try again.
export const isChannelUsed = (delivery) => ['pending', 'success'].includes(delivery?.stage);

/**
 * Stores the latest delivery state of a receipt channel, from a send response or a
 * receipt-delivered socket event, in the per-transaction cache that useReceiptDelivery reads.
 */
export const recordReceiptDelivery = (
  queryClient,
  { transactionId, medium, status, stage, origin }
) => {
  if (!transactionId || !medium) return;

  queryClient.setQueryData(receiptDeliveryKey(transactionId), (current = {}) => ({
    ...current,
    [medium]: { status, stage, origin: origin ?? current[medium]?.origin ?? null }
  }));
};
